import { render, staticRenderFns } from "./expertMatchingModal.vue?vue&type=template&id=47831985&"
import script from "./expertMatchingModal.vue?vue&type=script&lang=js&"
export * from "./expertMatchingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports